<!--<nav class="navbar navbar-light col-lg-12 col-12 p-0 fixed-top d-flex flex-row k-header">-->
<nav class="navbar navbar-light col-lg-12 col-12 p-0 fixed-top d-flex flex-row k-header light-border-new">

  <div class=" margin-top-7px margin-left-7px top-link">
    <button class="navbar-toggler navbar-toggler border-all-0px" type="button" (click)="openside()" *ngIf="displaybar">
      <i class="fa fa-bars"></i>
    </button>
    <button class="navbar-toggler navbar-toggler border-all-0px color-toggle" type="button" (click)="closeside()" *ngIf="displayclose">
      <i class="fa fa-bars"></i>
    </button>
    <div class="page-body-wrapper" *ngIf="display">
      <div class="row row-offcanvas row-offcanvas-right k-sidebar">
        <nav class="sidebar sidebar-offcanvas background-sidebar p-0" id="sidebar" style="width:290px;max-width:290px;margin-left:0;margin-top:0;height:100vh;position:fixed;top:0;left:0;z-index:2000;">
          <nurseapp-sidebar (closeside)="closeside()"></nurseapp-sidebar>
        </nav>
      </div>
    </div>
  </div>

  <div class="navbar-menu-wrapper d-flex align-self-stretch align-items-center">
    <button class="navbar-toggler navbar-toggler align-self-center mr-2 " type="button" data-toggle="minimize" hidden></button>
    <div class="row col-12 padding-lrs-0px">

      <div class="col-md-4 col-4 padding-lrs-0px  margin-tbs-auto">

        <ul class="navbar-nav ml-sm-auto navbar3 float-left top-link2">

          <li class="nav-item font-size-29px margin-left-10px">
            <a class="nav-item nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/latestdashboard2']">
              <i class="fas fa-home color-coral"></i>
            </a>

 
          </li>
        </ul>

        <!--<div class="navbar-nav ml-sm-auto navbar3 float-left  top-link2">
          <a class="nav-item nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/latestdashboard2']">
            HOME
          </a>
        </div>-->

        <ul class="navbar-nav ml-sm-auto navbar3 float-left top-link2" hidden>

          <li class="nav-item dropdown margin-top-10px margin-left-10px">
            <a class="nav-link count-indicator btn  button-hide margin-ts-0px padding-left-4 padding-right-4 " id="notificationDropdown" data-toggle="dropdown">

              <i class="fas fa-bars"></i>

            </a>

            <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3  right-two margin-all-0px padding-all-0px" aria-labelledby="notificationDropdown">
              <div class="alerts-one-main">
                <div class="new-alerts">

                  <div class="row padding-10px">

                    <div class="col-md-6">

                      <!--<span class="menu-title margin-left-3 font-size-11px"></span>-->
                      <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/newdashboard']"
                         title="Dashboard">
                        <i class="fas fa-th link6"></i> Dashboard


                      </a>

                    </div>



                  </div>
                  <!--<div class="row padding-10px">

              <div class="col-md-6">


                <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/counsellingregister']"
                   title="Schedule">
                  <i class="fas fa-calendar-check  link6"></i>Counselling Register


                </a>

              </div>



            </div>-->
                  <!--<div class="row padding-10px">

              <div class="col-md-6">


                <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/activitytracking']"
                   title="Find Suitable Jobs">
                  <i class="fas fa-calendar-check  link6"></i> Activities Tracking



                </a>

              </div>



            </div>-->
                  <div class="row padding-10px">

                    <div class="col-md-6">

                      <!--<span class="menu-title margin-left-3 font-size-11px"></span>-->
                      <!--<a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/ivfworkbench']"
                   title="Find Suitable Jobs">
                  <i class="fas fa-calendar-check  link6"></i> IVF



                </a>-->
                      <!--<li class="font-size-14" *ngIf="!IsAdmin"><a class="text-decoration color-lightgray font-size-14">Users</a></li>
                <li class="font-size-14 margin-top-5px margin-bottom-5px"
                    *ngIf="IsAdmin"><a class="nav-link-hand nav-new text-decoration color-dark" [routerLink]="['/healins/users']">Users</a></li>-->


                      <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/mis']"
                         title="MIS">
                        <i class="fas fa-calendar-check  link6"></i> MIS



                      </a>

                    </div>



                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>


        <ul class="navbar-nav ml-sm-auto  margin-left-2 top-link margin-top-0px height-50px">

          <!--<li class="nav-item line-height nav3 navbar-border-left navbar-border-right" [routerLinkActive]="['active']">
    <a class="nav-link nav2 margin-top-4px " [routerLink]="['/healins/newdashboard']"
       title="Dashboard"><i class="fas fa-th link6"></i></a>
  </li>-->
          <li class="nav-item line-height nav3 navbar-border-left  navbar-border-right padding-left-7px padding-right-7px" [routerLinkActive]="['active']" *canUserAccess="['HL_REG_2']">
            <a class="nav-link nav margin-top-0px padding-top-13px" [routerLink]="['/healins/dashboard']"
               title="Patients List"><i class="fas fa-users link6 dark-magenta"></i></a>
          </li>
          <li class="nav-item line-height nav3  navbar-border-right padding-left-7px padding-right-7px" [routerLinkActive]="['active']" *canUserAccess="['HL_SCH_1']">
            <a class="nav-link nav margin-top-0px padding-top-13px" [routerLink]="['/healins/fdappoinmentadv']"
               title="Appointments"><i class="far fa-calendar-alt link6 color-green"></i></a>
          </li>
          <li class="nav-item cursor line-height nav3  navbar-border-right padding-left-7px padding-right-7px" [routerLinkActive]="['active']" *canUserAccess="['HL_BL_3,HL_BL_4,HL_BL_5']">
            <a class="nav-link nav margin-top-0px padding-top-13px" title="Bills, Advances, Refunds"
               (click)="OpenBillAdv()">
              <i class="fas fa-rupee-sign link6 color-red"></i>
            </a>
          </li>
          <li class="nav-item line-height nav3  navbar-border-right padding-left-7px padding-right-7px" [routerLinkActive]="['active']" *canUserAccess="['HL_IVF_2']">
            <a class="nav-link nav margin-top-0px padding-top-13px" [routerLink]="['/healins/ivfdashboard2']"
               title="TreatmentCyles"><i class="fas fa-sync link6 color-blue"></i></a>
          </li>


          <!--<li class="nav-item line-height nav3 navbar-border-right" [routerLinkActive]="['active']">
    <a class="nav-link nav2 margin-top-4px" [routerLink]="['/healins/dashboard']"
       title="ProviderDashboard">Patients</a>
  </li>-->
          <!--<li class="nav-item line-height nav3 padding-left-0px padding-right-0px navbar-border-right" [routerLinkActive]="['active']">
    <ul class="navbar-nav ml-sm-auto navbar3 float-right">


      <li class="nav-item dropdown">
        <a class="nav-link nav2 margin-top-4px" id="notificationDropdown" data-toggle="dropdown">

          Follow Up <i class="fas fa-caret-down"></i>

        </a>
        <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3  margin-all-0px padding-all-0px" aria-labelledby="notificationDropdown">
          <div class="alerts-one-main">
            <div class="new-alerts">


              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">

                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/counsellingregister']"
                     title="Counselling Register">
                    <i class="fas fa-certificate  link6"></i> Counselling Register


                  </a>

                </div>



              </div>
              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/activitytracking']"
                     title="Activities Tracking">
                    <i class="fas fa-users link6"></i> Activities Tracking


                  </a>

                </div>



              </div>
              <div class="row ">

                <div class="col-md-8 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/testnusre/regcontracts']"
                     title="Reports">
                    <i class="fas fa-briefcase  link6"></i> Reports


                  </a>

                </div>



              </div>





            </div>
          </div>
        </div>
      </li>
    </ul>
  </li>-->

          <li class="nav-item line-height nav3  navbar-border-right padding-left-7px padding-right-7px" [routerLinkActive]="['active']" *canUserAccess="['HL_REPORT_SET_1']">
            <a class="nav-link nav margin-top-0px padding-top-13px" [routerLink]="['/healins/excelreporting']"
               title="Excel Reports"><i class="far fa-file-excel link6 adm-color-green"></i></a>
          </li>

          <li class="nav-item line-height nav3 padding-left-7px padding-right-7px" [routerLinkActive]="['active']" *canUserAccess="['HL_MI_1']">
            <a class="nav-link nav  " [routerLink]="['/healins/latestdashboard']"
               title="Dashboard"><i class="fas fa-chart-line link6 color-darkorange"></i></a>
          </li>
          <!--<li class="nav-item line-height nav3 padding-left-7px padding-right-7px" [routerLinkActive]="['active']" *canUserAccess="['HL_MI_1']">
    <a class="nav-link nav  " [routerLink]="['/healins/mis']"
       title="MIS"><i class="fas fa-chart-line link6 color-darkorange"></i></a>
  </li>-->
          <li class="nav-item line-height nav3 navbar-border-left padding-left-7px padding-right-7px">
            <a class="nav-link nav margin-top-0px padding-top-13px ms-app-launcher-btn" id="notificationDropdown" data-toggle="dropdown" title="App Launcher">
              <i class="fas fa-th link6 color-dodgerblue"></i>
            </a>
                <div class="dropdown-menu navbar-dropdown navbar-dropdown-position notification-drop-down ms-app-launcher-menu p-0 right-fuctions2" aria-labelledby="notificationDropdown">
                  
                  <!-- App Launcher Header -->
                  <div class="ms-app-launcher-header d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="ms-brand-badge me-2">
                        <i class="fas fa-th"></i>
                      </div>
                      <div>
                        <h6 class="ms-sidebar-title mb-0">App Launcher</h6>
                        <small class="ms-sidebar-subtitle">Quick access to all HIS modules</small>
                      </div>
                    </div>
                  </div>

                  <!-- App Launcher Megamenu Content -->
                  <div class="ms-app-launcher-body">
                    <div class="chatsd product-chart-wrapper product-chat-width-navbar agreement-chart-wrapper ps ps2 padding-lrt" data-ps-id="dfsfsde">
                      
                      <div class="row margin-left-zero">
                        
                        <!-- Column 1: Registration, Follow Up, Appointments -->
                        <div class="col-md-3 padding-right-0px">
                          <!-- Registration -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-id-card-alt text-primary"></i> Registration</li>
                            <li *canUserAccess="['HL_REG_1']">
                              <a class="ms-megamenu-link" [class.disabled]="TestVersion" (click)="OpenModal()">
                                <i class="fas fa-plus-circle text-primary"></i> <span>New Patient</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_REG_10']">
                              <a class="ms-megamenu-link" [class.disabled]="TestVersion" (click)="OpenEnquiry()">
                                <i class="fas fa-question-circle text-info"></i> <span>Enquiry</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_REG_2']">
                              <a class="ms-megamenu-link" [class.disabled]="TestVersion" [routerLink]="['/healins/dashboard']">
                                <i class="fas fa-users text-secondary"></i> <span>Patients List</span>
                              </a>
                            </li>
                          </ul>

                          <!-- Follow Up -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-user-clock text-purple"></i> Follow Up</li>
                            <li *canUserAccess="['HL_FU_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/counsellingregister']">
                                <i class="fas fa-clipboard-list"></i> <span>Counselling Register</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_FU_2']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/dailyworkbook']">
                                <i class="fas fa-book-open"></i> <span>Daily Work Book</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_FU_3']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/myworkbook']">
                                <i class="fas fa-bookmark"></i> <span>My Work Book</span>
                              </a>
                            </li>
                            <li><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Reports</span></a></li>
                          </ul>

                          <!-- Appointments -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="far fa-calendar-check text-success"></i> Appointments</li>
                            <li *canUserAccess="['HL_BL_HIDE']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/fdappoinment']">
                                <i class="fas fa-calendar-plus text-success"></i> <span>Book Appointments</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_SCH_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/fdappoinmentadv']">
                                <i class="fas fa-calendar-alt text-primary"></i> <span>All Branches Appointments</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Cancel Appointments</span></a></li>
                            <li *canUserAccess="['HL_BL_HIDE']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/visitreg']">
                                <i class="fas fa-clipboard-check text-info"></i> <span>Visit Register</span>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- Column 2: Billing & Pharmacy Billing -->
                        <div class="col-md-3 padding-left-0px">
                          <!-- Billing -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-receipt text-success"></i> Billing</li>
                            <li *canUserAccess="['HL_BL_5']" hidden>
                              <a class="ms-megamenu-link" (click)="OpenBillAdv()">
                                <i class="fas fa-plus-circle text-success"></i> <span>New Op Adv</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/opbilling']">
                                <i class="fas fa-file-invoice-dollar text-success"></i> <span>View Bills</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_ViewPPBills']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/opbillingpp']">
                                <i class="fas fa-file-invoice text-primary"></i> <span>View PP Bills</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_ViewNPBills']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/opbillingnp']">
                                <i class="fas fa-file-invoice text-info"></i> <span>View NP Bills</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_2']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/pharmacybill']">
                                <i class="fas fa-prescription-bottle-alt text-warning"></i> <span>View Pharmacy Bills</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_28']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/combinedbilling']">
                                <i class="fas fa-calculator text-purple"></i> <span>Bills (OP + RX)</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_HIDE']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/itemcatalogue']">
                                <i class="fas fa-book"></i> <span>Catalogue</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_HIDE']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/customerorders']">
                                <i class="fas fa-shopping-cart"></i> <span>Customer Orders</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_7']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/refundslist']">
                                <i class="fas fa-undo-alt text-danger"></i> <span>Refunds</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Advances</span></a></li>
                          </ul>

                          <!-- Billing Pharmacy -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul" *canUserAccess="['HL_BL_HIDE']">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-pills text-warning"></i> Billing (Pharmacy)</li>
                            <li><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>New Bill</span></a></li>
                            <li><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>View Bills</span></a></li>
                            <li><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Refund</span></a></li>
                          </ul>
                        </div>

                        <!-- Column 3: Bill Verifications, Lab, In Patient, EHR -->
                        <div class="col-md-3 padding-left-0px">
                          <!-- Bill Verifications -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-file-contract text-indigo"></i> Bill Verifications</li>
                            <li *canUserAccess="['HL_BV_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/billverfication']">
                                <i class="fas fa-check-double text-indigo"></i> <span>OP Bill Verifications</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BV_3']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/opbillservicestra']">
                                <i class="fas fa-route text-info"></i> <span>OP Service Tracking</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BV_2']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/ipbillverfication']">
                                <i class="fas fa-check-circle text-indigo"></i> <span>IP Bill Verifications</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BV_4']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/ipbillservicestra']">
                                <i class="fas fa-tasks text-primary"></i> <span>IP Service Tracking</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BV_5']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/strackingreport']">
                                <i class="fas fa-chart-line text-success"></i> <span>Service Tracking Report</span>
                              </a>
                            </li>
                          </ul>

                          <!-- Lab -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-vials text-purple"></i> Lab</li>
                            <li *canUserAccess="['HL_LAB_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/labdas']">
                                <i class="fas fa-microscope text-purple"></i> <span>Lab Orders</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Order Request</span></a></li>
                            <li *canUserAccess="['HL_BL_HIDE']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/lab']">
                                <i class="fas fa-flask text-primary"></i> <span>Specimen Collections</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Results</span></a></li>
                          </ul>

                          <!-- In Patient -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-procedures text-info"></i> In Patient</li>
                            <li *canUserAccess="['HL_AD_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/admissions']">
                                <i class="fas fa-hospital-user text-info"></i> <span>Admissions</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Billing</span></a></li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Discharges</span></a></li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Transfers</span></a></li>
                          </ul>

                          <!-- EHR -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul" *canUserAccess="['HL_BL_HIDE']">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-file-medical-alt text-danger"></i> EHR</li>
                            <li><a class="ms-megamenu-link is-disabled"><i class="fas fa-plus"></i> <span>Add Record</span></a></li>
                          </ul>
                        </div>

                        <!-- Column 4: IVF @ Home, IVF, ERP, Expense, Reports, Refunds -->
                        <div class="col-md-3 padding-left-0px">
                          <!-- IVF @ Home -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul" *canUserAccess="['HL_BL_HIDE']">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-heartbeat text-danger"></i> IVF &#64; Home</li>
                            <li>
                              <a class="ms-megamenu-link" (click)="OpenBill()">
                                <i class="fas fa-plus-circle text-danger"></i> <span>New Order</span>
                              </a>
                            </li>
                            <li>
                              <a class="ms-megamenu-link" [routerLink]="['/healins/iohorders']">
                                <i class="fas fa-boxes text-primary"></i> <span>Orders</span>
                              </a>
                            </li>
                          </ul>

                          <!-- IVF -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-dna text-primary"></i> IVF</li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-plus"></i> <span>New Cycle</span></a></li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Donors</span></a></li>
                            <li *canUserAccess="['HL_IVF_2']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/ivfdashboard2']">
                                <i class="fas fa-sync-alt text-primary"></i> <span>Treatment Cycles</span>
                              </a>
                            </li>
                            <li *canUserAccess="['EggDonorDashboard']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/eggdonordashboard']">
                                <i class="fas fa-female text-pink"></i> <span>Egg Donors</span>
                              </a>
                            </li>
                            <li *canUserAccess="['FolScanDashboard']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/follicularscansdashboard']">
                                <i class="fas fa-search-plus text-info"></i> <span>Follicular Scans</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_IVF_3']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/ivfworkbench']">
                                <i class="fas fa-laptop-medical text-success"></i> <span>IVF Work Bench</span>
                              </a>
                            </li>
                          </ul>

                          <!-- ERP -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-boxes text-secondary"></i> ERP</li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Purchases</span></a></li>
                            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Stores</span></a></li>
                            <li *canUserAccess="['HL_ER_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/ConsumptionEntry']">
                                <i class="fas fa-box-open text-primary"></i> <span>Consumption Entry</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_18']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/deptconsumptionentrydas']">
                                <i class="fas fa-building text-info"></i> <span>Dept Consumption</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_2']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/MaterialTracking']">
                                <i class="fas fa-truck-loading text-warning"></i> <span>Material Tracking</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_3']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/servicesrevenue']">
                                <i class="fas fa-chart-pie text-success"></i> <span>Services Revenue</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_4']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/purchaseindent']">
                                <i class="fas fa-file-signature text-secondary"></i> <span>Purchase Indents</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_5']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/purchaseorder']">
                                <i class="fas fa-file-invoice text-primary"></i> <span>Purchase Orders</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_6']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/materialinvoice']">
                                <i class="fas fa-file-alt text-info"></i> <span>Vendor Invoices</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_ViewPOVI']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/povi']">
                                <i class="fas fa-file-contract text-indigo"></i> <span>Order Cum Invoice</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_ER_10']"><a class="ms-megamenu-link is-disabled"><i class="fas fa-lock"></i> <span>Stock Adjustments</span></a></li>
                          </ul>

                          <!-- Expense & Reports -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-wallet text-warning"></i> Expense & Reports</li>
                            <li *canUserAccess="['HL_EXP_2']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/Expensevo']">
                                <i class="fas fa-money-check-alt text-warning"></i> <span>Expense Voucher</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_EXP_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/ExpenseManagement']">
                                <i class="fas fa-file-alt text-info"></i> <span>Expense Management</span>
                              </a>
                            </li>
                            <li *canUserAccess="['HL_REPORT_SET_1']">
                              <a class="ms-megamenu-link" [routerLink]="['/healins/excelreporting']">
                                <i class="far fa-file-excel text-success"></i> <span>Excel Reports</span>
                              </a>
                            </li>
                          </ul>

                          <!-- Refunds -->
                          <ul class="padding-left-0px margin-top-10 ms-megamenu-ul" *canUserAccess="['HL_BL_HIDE']">
                            <li class="ms-megamenu-cat-title"><i class="fas fa-undo-alt text-danger"></i> Refunds</li>
                            <li><a class="ms-megamenu-link" [routerLink]="['/healins/opbilling']"><i class="fas fa-history"></i> <span>History</span></a></li>
                            <li><a class="ms-megamenu-link" [routerLink]="['/healins/ApprovalList']"><i class="fas fa-check-square"></i> <span>Approvals</span></a></li>
                            <li><a class="ms-megamenu-link" [routerLink]="['/healins/customerorders']"><i class="fas fa-credit-card"></i> <span>Payments</span></a></li>
                          </ul>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </li>

          <!--<li class="nav-item line-height nav3 navbar-border-right padding-left-0px padding-right-0px" [routerLinkActive]="['active']">
    <ul class="navbar-nav ml-sm-auto navbar3 float-right">


      <li class="nav-item dropdown">
        <a class="nav-link nav2 margin-top-4px" id="notificationDropdown" data-toggle="dropdown">

          <i class="fa fa-calendar-alt"></i> <i class="fas fa-caret-down margin-left-10px"></i>

        </a>
        <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3  margin-all-0px padding-all-0px" aria-labelledby="notificationDropdown">
          <div class="alerts-one-main">
            <div class="new-alerts">


              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/Schedular']"
                     title="Counselling Register">
                    <i class="fas fa-certificate  link6"></i> Patient visit Register


                  </a>

                </div>



              </div>
              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/Schedular']"
                     title="Activities Tracking">
                    <i class="fas fa-users link6"></i> Booking/Cancellation


                  </a>

                </div>



              </div>
              <div class="row ">

                <div class="col-md-8 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/testnusre/Schedular']"
                     title="Reports">
                    <i class="fas fa-briefcase  link6"></i> Reports


                  </a>

                </div>



              </div>





            </div>
          </div>
        </div>
      </li>
    </ul>
  </li>-->
          <!--<li class="nav-item line-height nav3 navbar-border-right padding-left-0px padding-right-0px" [routerLinkActive]="['active']">
    <ul class="navbar-nav ml-sm-auto navbar3 float-right">


      <li class="nav-item dropdown">
        <a class="nav-link nav2 margin-top-4px" id="notificationDropdown" data-toggle="dropdown">

          <i class="fas fa-flask"></i> <i class="fas fa-caret-down margin-left-10px"></i>

        </a>
        <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3  margin-all-0px padding-all-0px" aria-labelledby="notificationDropdown">
          <div class="alerts-one-main">
            <div class="new-alerts">


              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/lab']"
                     title="Counselling Register">
                    <i class="fas fa-certificate  link6"></i> Order Requests


                  </a>

                </div>



              </div>
              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/lab']"
                     title="Activities Tracking">
                    <i class="fas fa-users link6"></i> Specimen Collection


                  </a>

                </div>



              </div>
              <div class="row ">

                <div class="col-md-8 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/testnusre/lab']"
                     title="Reports">
                    <i class="fas fa-briefcase  link6"></i> Results


                  </a>

                </div>



              </div>





            </div>
          </div>
        </div>
      </li>
    </ul>
  </li>-->
          <!--<li class="nav-item line-height nav3 padding-left-0px padding-right-0px" [routerLinkActive]="['active']">
    <ul class="navbar-nav ml-sm-auto navbar3 float-right">


      <li class="nav-item dropdown">
        <a class="nav-link nav2 margin-top-4px" id="notificationDropdown" data-toggle="dropdown">

          <i class="fa fa-calendar"></i> <i class="fas fa-caret-down margin-left-10px"></i>

        </a>
        <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3  margin-all-0px padding-all-0px" aria-labelledby="notificationDropdown">
          <div class="alerts-one-main">
            <div class="new-alerts">


              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/billing']"
                     title="Counselling Register">
                    <i class="fas fa-certificate  link6"></i> Find Patients


                  </a>

                </div>



              </div>
              <div class="row ">

                <div class="col-md-12 padding-right-0px margin-left-10px">


                  <a class="nav-link nav2 color-datacolor" [routerLink]="['/healins/billing']"
                     title="Activities Tracking">
                    <i class="fas fa-users link6"></i> All Bills


                  </a>

                </div>



              </div>






            </div>
          </div>
        </div>
      </li>
    </ul>
  </li>-->

        </ul>
      </div>
      <div class="col-md-3 col-4 margin-tb-auto padding-lrs-0px">
        <div class="margin-lr-auto top-link">
          <a class="navbar-brand brand-logo nav-link-hand">
          <img [src]='logo'
               [style.width.px]="logowidth" 
               [style.height.px]="logoheight"
               class="margin-top-21px-small margin-top-m">
          </a>

          <a class="navbar-brand brand-logo-mini" data-toggle="tooltip" data-placement="bottom" title="IVFSYS"></a>
        </div>
        <div class="margin-lr-auto top-link2">
          <a class="navbar-brand brand-logo nav-link-hand text-align-center"><img [src]='logo' class="img-small"></a>

          <a class="navbar-brand brand-logo-mini" data-toggle="tooltip" data-placement="bottom" title="IVFSYS"></a>
        </div>
      </div>
      <div class="col-md-5 col-4 margin-top-auto padding-lrs-0px">


        <div class="row top-link d-flex align-items-center justify-content-between flex-nowrap margin-all-0px">
          <div class="col-md-5 col-5 padding-lrs-0px">
            <reader></reader>
          </div>
          <div class="col-md-7 col-7 padding-lrs-0px d-flex align-items-center justify-content-end">
            <ul class="navbar-nav navbar3 top-link d-flex align-items-center flex-row flex-nowrap margin-all-0px">

              <li class="nav-item dropdown margin-right-8px">
                <a class="nav-link count-indicator padding-top-8px" id="notificationDropdown" data-toggle="dropdown" title="My Account,Skills,etc...,">
                  <img class="img-circle image2 margin-t-auto nav-link-hand margin-right-0px margin-bottom-3px" [src]='NavActorImageFile' onError="this.src='personalinfo.png';" height="30px"
                       width="30px">
                  <!--<img class="img-circle nav-link-hand" *ngIf="!NavActorImageFile" height="30px"
            width="30px"
            src="personalinfo.png" alt="" />-->

                </a>
                <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3 right-one margin-all-0px padding-all-0px" aria-labelledby="notificationDropdown">
                  <div class="alerts-one-main">
                    <div class="new-alerts">
                      <div class="row border-bottom-schedulecard navbar-links-border margin-left-zero margin-right">
                        <div class="col-md-4">
                          <img class="img-circle img-size2" [src]='NavActorImageFile' onError="this.src='personalinfo.png';" height="53px"
                               width="53px">
                          <!--<img class="img-circle img-size2" *ngIf="!NavActorImageFile" height="53px"
                    width="53px"
                    src="personalinfo.png" alt="" />-->
                        </div>
                        <div class="col-md-8 margin-all padding-lr-0px">
                          <div class="new-alerts">
                            <div class="user-status ">

                              <div class="user-title title-text-color nameDisplay margin-top-0px" *ngIf="DispalyName">{{DispalyName}}</div>
                              <div class="user-title title-text-color font-size-12px nameDisplay margin-top-0px" *ngIf="BranchName">{{BranchName}}</div>
                              <div class="user-title title-text-color font-size-12px nameDisplay margin-top-0px" *ngIf="RoleName">{{RoleName}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row padding-10px">

                        <div class="col-md-10">

                          <ul class="padding-left-0px margin-top-10 margin-left-40px">


                            <li class="font-size-14 margin-top-5px margin-bottom-5px">
                              <a class="nav-link-hand nav-new text-decoration color-dark"
                                 [routerLink]="['/Changepassword']">
                                Change Password

                              </a>
                            </li>
                            <li class="font-size-14 margin-top-5px margin-bottom-5px">
                              <a class="nav-link-hand nav-new text-decoration color-dark"
                                 [routerLink]="['/signinpage']">
                                Sign Out

                              </a>
                            </li>

                          </ul>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </li>

              <li class="nav-item dropdown margin-right-8px" *canUserAccess="['HL_SET_1']">
                <!--'Settings' should be viewable for anyone with authorization ONLY-->
                <a class="nav-link count-indicator padding-top-8px" id="settingsDropdown" data-toggle="dropdown" title="Settings">
                  <i class="fas fa-cog color-darkgray font-size-16px"></i>
                </a>
                <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3 right-fuctions margin-all-0px padding-all-0px" aria-labelledby="settingsDropdown">
                  <div class="alerts-one-main">
                    <div class="new-alerts">

                      <div class="chatsd product-chart-wrapper product-chat-width-navbar agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                        <div class="row margin-left-zero">
                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Masters</li>
                              <li *canUserAccess="['HL_PR_SET_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/branches']">
                                  Branches
                                </a>
                              </li>
                              <li *canUserAccess="['HL_PR_SET_2']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/departments']">
                                  Departments
                                </a>
                              </li>
                              <li *canUserAccess="['HL_PR_SET_3']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess('Employee')">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/employee']">
                                  Employee
                                </a>
                              </li>
                              <li *canUserAccess="['HL_PR_SET_4']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess('External Doctors')">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/externaldoctors']">
                                  External Doctors
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div class="col-md-3">

                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Services Setup</li>
                              <li *canUserAccess="['HL_SV_SET_1']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Service Category</a></li>
                              <li *canUserAccess="['HL_SV_SET_2']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Service</a></li>
                              <li *canUserAccess="['HL_SV_SET_3']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Branch Service</a></li>
                              <li *canUserAccess="['HL_SV_SET_4']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Consultant Service</a></li>
                              <li *canUserAccess="['HL_SV_SET_5']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/service']">
                                  Consultant Charges

                                </a>
                              </li>
                              <li *canUserAccess="['HL_SV_SET_6']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/bgs']">
                                  BGS

                                </a>
                              </li>
                              <li *canUserAccess="['HL_SV_SET_9']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/servicespanel']">
                                  Services Panel

                                </a>
                              </li>
                              <li *canUserAccess="['HL_SV_SET_7']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Packages</a></li>
                              <li *canUserAccess="['HL_SV_SET_8']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Profiles</a></li>
                            </ul>
                          </div>
                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Lab Setup</li>
                              <li *canUserAccess="['HL_LS_SET_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px"><a class="nav-link-hand nav-new text-decoration color-dark" [routerLink]="['/healins/labstep']">Lab Departments</a></li>
                              <li *canUserAccess="['HL_LS_SET_2']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Observations</a></li>
                              <li *canUserAccess="['HL_LS_SET_3']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Tests</a></li>
                              <li *canUserAccess="['HL_LS_SET_4']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Lab Access Rights</a></li>

                            </ul>
                          </div>
                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Coded Values</li>
                              <li *canUserAccess="['HL_CV_SET_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess('Coded Values New')">
                                <a class="nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/CodeTypes']">
                                  Code Types
                                </a>
                              </li>
                              <li *canUserAccess="['HL_CV_SET_2']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Coded Values</a></li>


                            </ul>
                          </div>

                        </div>
                        <div class="row margin-left-zero">
                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">ADT Setup</li>
                              <li *canUserAccess="['HL_AD_SET_1']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Care Units</a></li>
                              <li *canUserAccess="['HL_AD_SET_2']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Ward &amp; Rooms</a></li>


                            </ul>
                          </div>
                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">User Management</li>
                              <li *canUserAccess="['HL_UM_SET_1']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">My Settings</a></li>
                              <li *canUserAccess="['HL_UM_SET_2']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess('Department')">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/module']">
                                  Module
                                </a>
                              </li>
                              <li *canUserAccess="['HL_UM_SET_3']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess('Department')">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/features']">
                                  Features
                                </a>
                              </li>
                              <li *canUserAccess="['HL_UM_SET_4']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess('Department')">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/roles']">
                                  Roles
                                </a>
                              </li>
                              <!--<li class="font-size-14" *ngIf="!IsAdmin"><a class="text-decoration color-lightgray font-size-14">Users</a></li>-->
                              <li *canUserAccess="['HL_UM_SET_5']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px"><a class="nav-link-hand nav-new text-decoration color-dark" [routerLink]="['/healins/users']">Users</a></li>
                              <li *canUserAccess="['HL_UM_SET_6']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess('Department')">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/accessrights']">
                                  Access Rights
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div class="col-md-3">

                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">ERP Setup</li>
                              <li *canUserAccess="['HL_ERS_SET_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand text-decoration color-data2 nav-new"
                                   [routerLink]="['/healins/vendors']">
                                  Vendors
                                </a>
                              </li>
                              <!--<li class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Vendors</a></li>-->
                              <li *canUserAccess="['HL_ERS_SET_2']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Vendor Contacts</a></li>
                              <li *canUserAccess="['HL_ERS_SET_3']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Stores &amp; Sub-Stores </a></li>
                              <li *canUserAccess="['HL_ERS_SET_4']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Layout &amp; Locations</a></li>
                              <li *canUserAccess="['HL_ERS_SET_5']"
                                  class="font-size-14">
                                <a class="text-decoration color-lightgray font-size-14">
                                  Material Groups

                                </a>
                              </li>
                              <!--<li class="font-size-14"><a class="text-decoration color-lightgray font-size-14" [hidden]="!HasAccess('Materials')"> Materials</a></li>-->
                              <li *canUserAccess="['HL_ERS_SET_6']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand text-decoration color-data2 nav-new"
                                   [routerLink]="['/healins/materialconsumption']">
                                  Materials
                                </a>
                              </li>
                              <li *canUserAccess="['HL_ERS_SET_7']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Store Materials</a></li>
                              <li *canUserAccess="['HL_ERS_SET_8']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Store Access</a></li>
                              <li *canUserAccess="['HL_ERS_SET_9']"><a class="text-decoration color-lightgray font-size-14">Tax</a></li>
                            </ul>
                          </div>
                          <div class="col-md-3">

                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Appointments SetUp</li>
                              <!--<li class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Session</a></li>-->
                              <li *canUserAccess="['HL_APP_SET_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class=" nav-link-hand text-decoration color-data2 nav-new"
                                   [routerLink]="['/healins/Session']">
                                  Session

                                </a>
                                <!--<a class=" text-decoration color-lightgray font-size-14">
                            Treatment Cycle
                          </a>-->
                              </li>
                              <li *canUserAccess="['HL_APP_SET_2']"
                                  class="font-size-14"><a class="text-decoration color-lightgray font-size-14">Calendars</a></li>

                            </ul>
                          </div>
                        </div>
                        <div class="row margin-left-zero">
                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Setup</li>
                              <!--<li class="font-size-14"><a class="text-decoration color-lightgray font-size-14">IVF Activities</a></li>-->
                              <li *canUserAccess="['HL_SETUP_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class=" nav-link-hand text-decoration color-data2 nav-new"
                                   [routerLink]="['/healins/ivfmasterlist']">
                                  IVF Activities

                                </a>
                                <!--<a class=" text-decoration color-lightgray font-size-14">
                            Treatment Cycle
                          </a>-->
                              </li>


                            </ul>
                          </div>

                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Report Setup</li>
                              <li *canUserAccess="['HL_RS_SET_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/reportattributes']">
                                  Report Attributes
                                </a>
                              </li>
                              <li *canUserAccess="['HL_RS_SET_2']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/reportregister']">
                                  Report Register
                                </a>
                              </li>
                            </ul>
                          </div>

                          <div class="col-md-3">
                            <ul class="padding-left-0px margin-top-10">
                              <li class="font-size-16px color-Assign">Articles Setup</li>
                              <li *canUserAccess="['HL_AR_SET_1']"
                                  class="font-size-14 margin-top-5px margin-bottom-5px">
                                <a class="nav-link-hand nav-new text-decoration color-dark"
                                   [routerLink]="['/healins/articles']">
                                  Articles
                                </a>
                              </li>

                            </ul>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </li>

              <li class="nav-item margin-right-8px" *canUserAccess="['HL_ERP_SET_1']">
                <a class="nav-link erpsetup font-weight-bold font-size-12px cursor-pointer" (click)="OpenModalErp()" title="ERP Setup">
                  ERP
                </a>
              </li>

              <li class="nav-item dropdown margin-right-8px">
                <a class="nav-link count-indicator padding-top-8px" id="helpDropdown" data-toggle="dropdown" title="Help">
                  <i class="fas fa-question-circle icon-color-scm font-size-16px"></i>
                </a>
                <div class="dropdown-menu navbar-dropdown notification-drop-down pl-3 pr-3 right-one margin-all-0px padding-all-0px height-9rem" aria-labelledby="helpDropdown">
                  <div class="alerts-one-main">
                    <div class="new-alerts">
                      <div class="row margin-left-zero">
                        <div class="col-md-3">
                          <ul class="padding-left-0px margin-top-10">
                            <li class="font-size-16px color-Assign">Help</li>
                            <li class="font-size-14" [hidden]="!HasAccess('Materials')">
                              <a class="nav-link-hand nav-new text-decoration color-dark"
                                 [routerLink]="['/healins/ivfhelp']">
                                IVF
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="nav-item dropdown">
                <a class="nav-link count-indicator padding-top-8px nav-link-hand" id="themeDropdown" data-toggle="dropdown" title="Application Themes">
                  <i class="fas fa-ellipsis-v icon-color-scm font-size-16px"></i>
                </a>
                <div class="dropdown-menu navbar-dropdown notification-drop-down p-0 right-one margin-all-0px ms-theme-dropdown-menu" aria-labelledby="themeDropdown">
                  <div class="ms-theme-popup-header">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="font-weight-bold font-size-13px text-dark">
                        <i class="fas fa-palette text-primary margin-right-6px"></i> Application Themes
                      </span>
                      <span class="badge badge-pill badge-primary font-size-10px">5 Themes</span>
                    </div>
                  </div>
                  <div class="ms-theme-popup-body">
                    <div class="ms-theme-option-item" *ngFor="let t of themes" (click)="selectTheme(t.id)" [class.active]="currentTheme === t.id">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                          <span class="ms-theme-color-badge" [style.background]="t.previewGradient"></span>
                          <div class="margin-left-10px">
                            <div class="font-weight-bold font-size-12px text-dark">{{t.name}}</div>
                            <div class="font-size-10px text-muted">{{t.description}}</div>
                          </div>
                        </div>
                        <i class="fas fa-check-circle text-primary font-size-14px" *ngIf="currentTheme === t.id"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

            </ul>
          </div>

        </div>

        <div class="row top-link2" hidden>
          <div class="offset-md-9 col-md-1 offset-11 col-1 padding-right-0px padding-left-0px">
            <ul class="navbar-nav ml-sm-auto navbar3 float-right">


              <li class="nav-item dropdown">
                <a class="nav-link count-indicator padding-top-8px" id="notificationDropdown" data-toggle="dropdown" title="My Account,Skills,etc...,">
                  <img class="img-circle  margin-top-img nav-link-hand" [src]='NavActorImageFile' onError="this.src='personalinfo.png';" height="30px"
                       width="30px">
                  <!--<img class="img-circle nav-link-hand" *ngIf="!NavActorImageFile" height="30px"
            width="30px"
            src="personalinfo.png" alt="" />-->

                </a>
                <div class="dropdown-menu navbar-dropdown notification-drop-down  pl-3 pr-3 right-signout margin-all-0px padding-all-0px" aria-labelledby="notificationDropdown">
                  <div class="alerts-one-main">
                    <div class="new-alerts">
                      <div class="row border-bottom-schedulecard navbar-links-border margin-left-zero margin-right">
                        <div class="col-md-4 col-3 padding-left-0px">
                          <img class="img-circle img-size2" [src]='NavActorImageFile' onError="this.src='personalinfo.png';" height="53px"
                               width="53px">
                          <!--<img class="img-circle img-size2" *ngIf="!NavActorImageFile" height="53px"
                    width="53px"
                    src="personalinfo.png" alt="" />-->
                        </div>
                        <div class="col-md-8  col-9 margin-all padding-left-0px">
                          <div class="new-alerts">
                            <div class="user-status ">

                              <div class="user-title title-text-color nameDisplay margin-top-0px text-align-center" *ngIf="DispalyName">{{DispalyName}}</div>


                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row padding-10px">
                        <!--<div class="col-md-6 text-align-center">
                    <a class="nav-link nav3 nav-color2"
                       [routerLink]="['/healins/service']">
                      <i class="fas fa-cog font-size-icon icon-color-scm"></i>
                      <div>
                        <span class="menu-title margin-left-3 font-size-11px">Service</span>
                      </div>
                    </a>

                  </div>-->
                        <!--<div class="col-md-6 text-align-center">
                    <a class="nav-link nav3 nav-color2"
                       [routerLink]="['/signinpage']"
                       title="Sign Out">
                      <i class="fas fa-sign-out-alt font-size-icon icon-color-signout"></i>
                      <div>
                        <span class="menu-title margin-left-3 font-size-11px">Sign Out</span>
                      </div>
                    </a>
                  </div>-->
                        <div class="col-md-10">

                          <ul class="padding-left-0px margin-top-10">


                            <li class="font-size-14 margin-top-5px margin-bottom-5px">
                              <a class="nav-link-hand nav-new text-decoration color-dark"
                                 [routerLink]="['/Changepassword']">
                                Change Password

                              </a>
                            </li>
                            <li class="font-size-14 margin-top-5px margin-bottom-5px">
                              <a class="nav-link-hand nav-new text-decoration color-dark"
                                 [routerLink]="['/signinpage']">
                                Sign Out

                              </a>
                            </li>

                          </ul>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
     
        <!--SmartPhoneMenu-->


      </div>




    </div>






  </div>







</nav>
